jQuery(function ($) {
  $('[data-ly-slick="category"]').each(function () {
    var $slider = $(this);
    if ($slider.hasClass('slick-initialized')) return;

    var arrowsSelector = $slider.attr('data-ly-arrows');
    var $wrap = arrowsSelector ? $(arrowsSelector) : $();

    var $prev = $wrap.find('.slider-button--prev');
    var $next = $wrap.find('.slider-button--next');

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      speed: 400,
      adaptiveHeight: false,
      variableWidth: false,
      centerMode: false,
      rows: 0,
      arrows: false, // ✅ IMPORTANT : Slick ne crée plus .slick-prev/.slick-next
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 3 } },
        { breakpoint: 768,  settings: { slidesToShow: 2 } }
      ]
    });

    // ✅ Tes flèches contrôlent Slick (zéro conflit)
    $prev.off('click.lyCat').on('click.lyCat', function (e) {
      e.preventDefault();
      $slider.slick('slickPrev');
    });

    $next.off('click.lyCat').on('click.lyCat', function (e) {
      e.preventDefault();
      $slider.slick('slickNext');
    });

    function syncDisabled() {
      var slick = $slider.slick('getSlick');
      var atStart = slick.currentSlide === 0;
      var atEnd = slick.currentSlide >= (slick.slideCount - slick.options.slidesToShow);

      $prev.prop('disabled', atStart);
      $next.prop('disabled', atEnd);
    }

    $slider.on('init reInit afterChange', syncDisabled);
    syncDisabled();

    setTimeout(function () { $slider.slick('setPosition'); }, 0);
  });
});